// Which ordering apps the server offers, cached so buttons appear without waiting.
import { useEffect, useState } from 'preact/hooks';
import { api, ApiError } from './api';
import { load, save } from './storage';
import type { Money, Provider } from './types';

const KEY = 'er.cache.providers';

/** The providers the server offers ([] when ordering is off), refreshed on mount. */
export function useProviders(): [Provider[], () => void] {
  const [ps, setPs] = useState<Provider[]>(() => load<Provider[]>(KEY, []));
  const refresh = () =>
    api.providers().then((p) => { setPs(p); save(KEY, p); }).catch((e: ApiError) => {
      if (e.status === 404) { setPs([]); save(KEY, []); } // ordering is switched off on this server
    });
  useEffect(() => { refresh(); }, []);
  return [ps, refresh];
}

/** Opens the provider's sign-in page; it sends the user back to returnTo afterwards. */
export async function startConnect(provider: string, returnTo: string) {
  const { url } = await api.connect(provider, returnTo);
  location.assign(url);
}

export function money(m: Money | undefined): string {
  if (!m) return '';
  try {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: m.currency || 'INR', maximumFractionDigits: m.amount % 100 ? 2 : 0 }).format(m.amount / 100);
  } catch {
    return `₹${(m.amount / 100).toFixed(2)}`;
  }
}
